import _googleMapStore from './maps/google-map.store'
import _adminPanelStore from './admin/panel.store'
import {combineReducers} from "redux";

const reducers = combineReducers({
    map: _googleMapStore,
    adminPanel: _adminPanelStore
})

export default reducers